import {uniqueId} from '@/lib/utils';
import { setConfirmInfo, TConfirmInfo } from '@/stores/ui.store.ts';

export function useConfirmOnClick<P = undefined>(props: TConfirmInfo<P>) {
  return (payload: P | any = undefined) => {
    const _props = {...props};
    if (!_props.id) {
      props.id = uniqueId('confirm_');
    }
    if (payload !== undefined) {
      _props.payload = payload;
    }
    if (_props.onConfirm) {
      if (_props.onShow) {
        const updated = _props.onShow(payload);
        if (updated) {
          if (updated.title) {
            _props.title = updated.title;
          }
          if (updated.message) {
            _props.message = updated.message;
          }
        }
      }
      setConfirmInfo(_props as any);
    }
  };
}
